<div class="client-data">
    <div class="client-data__name">
        <mat-icon class="client-data__name__icon" svgIcon="clientIcon">clientIcon</mat-icon>
        <span class="client-data__name__text">{{clientName()}}</span>
        @if (isVip()) {
            <mat-icon class="client-data__name__vip-icon" svgIcon="clientVipIcon">clientVipIcon</mat-icon>
        }
    </div>
    <div class="client-data__info-personal">
        <div class="client-data__info-personal__doc-num">
            <mat-icon class="client-data__info-personal__icon" svgIcon="docNumberIcon">docNumberIcon</mat-icon><span class="client-data__info-personal__text">{{clientDocument()}}</span>
        </div>
        <div class="client-data__info-personal__phone">
            <mat-icon class="client-data__info-personal__icon" fontSet="material-icons">call</mat-icon><span class="client-data__info-personal__text">{{clientPhone()}}</span>
        </div>
    </div>
    <div class="client-data__email">
        <mat-icon class="client-data__email__icon" fontSet="material-icons">mail</mat-icon><span class="client-data__email__text">{{clientEmail()}}</span>
    </div>
</div>
